import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { appEnv } from 'app/core/environment';
import { routerHistory } from 'app/shared/frames/AppRoute';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import reportWebVitals from './report-web-vitals';
import 'app/styles/index.css';

const container = document.getElementById('root');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  container
);

Sentry.init({
  dsn: appEnv.SENTRY_DSN,
  environment: appEnv.SENTRY_ENV,
  release: appEnv.RELEASE_ID,
  normalizeDepth: 10,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation:
        Sentry.reactRouterV5Instrumentation(routerHistory),
    }),
  ],
  ignoreErrors: ['ResizeObserver loop limit exceeded'],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console dot log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
